import { DEFAULT_TIMEOUT as e } from "../config/constants.js";
function T(t, o = e) {
  const i = o || e, r = new Promise(
    (n, m) => setTimeout(() => m(new Error("Timeout")), i)
  );
  return Promise.race([t, r]);
}
export {
  T as withTimeout
};
